export default "__VITE_ASSET__mt3TEIfq__";